function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var email = require('./email');
var TICKERS = ['ERC-SAITO', 'BEP-SAITO'];
var MAX_DEPOSIT = 1000000;
var MIN_TREASURY = 1000;
var OPEN_STATUSES = ['inbound_awaiting', 'inbound_broadcast', 'inbound_confirmed', 'outbound_awaiting', 'outbound_broadcast', 'treasury_submitted', 'treasury_accepted'];
var MigrationService = /*#__PURE__*/function () {
  function MigrationService(app, mod) {
    _classCallCheck(this, MigrationService);
    this.app = app;
    this.mod = mod;
  }

  /**
   * Shared 1:1 issuance policy used by automatic matching, manual confirmation,
   * treasury payout signing, and admin approval.
   */
  return _createClass(MigrationService, [{
    key: "allocationForDeposit",
    value: function allocationForDeposit(amount) {
      var value = Number(amount);
      if (!Number.isFinite(value) || value <= 0) {
        throw new Error('Migration amount must be positive');
      }
      if (value > MAX_DEPOSIT) {
        throw new Error('Migration amount exceeds the 1000000 cap');
      }
      return value;
    }

    /**
     * Start an automatic migration for the Migrate button: validate the request,
     * gate on treasury funds, reserve a Mixin deposit address, and return the
     * instructions the client displays.
     */
  }, {
    key: "startMigration",
    value: function () {
      var _startMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(publicKey, ticker) {
        var crypto, nolan, available, reserved, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (publicKey) {
                _context.n = 1;
                break;
              }
              return _context.a(2, {
                error: 'A Saito address is required',
                ticker: ticker
              });
            case 1:
              if (TICKERS.includes(ticker)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, {
                error: "Unsupported wrapped SAITO ticker: ".concat(ticker),
                ticker: ticker
              });
            case 2:
              crypto = (this.mod.crypto_mods || []).find(function (item) {
                return item.ticker === ticker;
              }) || null;
              if (crypto !== null && crypto !== void 0 && crypto.asset_id) {
                _context.n = 3;
                break;
              }
              return _context.a(2, {
                error: "".concat(ticker, " is not installed"),
                ticker: ticker
              });
            case 3:
              _context.n = 4;
              return this.app.wallet.getBalance('SAITO');
            case 4:
              nolan = _context.v;
              available = Number(this.app.wallet.convertNolanToSaito(nolan));
              if (!Number.isFinite(available) || available < 0) {
                available = 0;
              }
              if (available > MAX_DEPOSIT) {
                available = MAX_DEPOSIT;
              } else {
                email.sendLowBalanceEmail(this.app, available);
              }
              if (!(available < MIN_TREASURY)) {
                _context.n = 5;
                break;
              }
              return _context.a(2, {
                error: 'Insufficient balance in the Migration bot',
                ticker: ticker
              });
            case 5:
              _context.p = 5;
              _context.n = 6;
              return this.mod.transfers.reserveAddress(publicKey, {
                purpose: 'migration',
                ticker: ticker,
                recipient_publickey: publicKey,
                inbound_amount: '',
                outbound_amount: '',
                inbound_confirmations_required: 0,
                payload: '',
                request_id: '',
                outbound_address: publicKey
              });
            case 6:
              reserved = _context.v;
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              return _context.a(2, {
                error: (_t === null || _t === void 0 ? void 0 : _t.message) || String(_t),
                ticker: ticker
              });
            case 8:
              return _context.a(2, this.clientReservation(reserved));
          }
        }, _callee, this, [[5, 7]]);
      }));
      function startMigration(_x, _x2) {
        return _startMigration.apply(this, arguments);
      }
      return startMigration;
    }()
  }, {
    key: "getMigrationStatus",
    value: function () {
      var _getMigrationStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(publicKey, id) {
        var rows, row;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!publicKey || !id)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, {
                error: 'Migration status requires an id'
              });
            case 1:
              _context2.n = 2;
              return this.mod.database.getTransfers({
                id: Number(id),
                purpose: 'migration',
                mode: 'automatic',
                requester_publickey: publicKey
              });
            case 2:
              rows = _context2.v;
              row = rows === null || rows === void 0 ? void 0 : rows[0];
              if (row) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, {
                error: 'Migration request not found'
              });
            case 3:
              return _context2.a(2, this.clientReservation(row));
          }
        }, _callee2, this);
      }));
      function getMigrationStatus(_x3, _x4) {
        return _getMigrationStatus.apply(this, arguments);
      }
      return getMigrationStatus;
    }()
    /**
     * Extend an unpaid automatic migration reservation by resetting created_at,
     * which moves reserved_until forward by the shared reservation period.
     */
  }, {
    key: "extendReservation",
    value: function () {
      var _extendReservation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(publicKey, id) {
        var rows, row, now;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!publicKey || !id)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, {
                error: 'Migration extension requires an id'
              });
            case 1:
              _context3.n = 2;
              return this.mod.database.getTransfers({
                id: Number(id),
                purpose: 'migration',
                mode: 'automatic',
                requester_publickey: publicKey
              });
            case 2:
              rows = _context3.v;
              row = rows === null || rows === void 0 ? void 0 : rows[0];
              if (row) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, {
                error: 'Migration request not found'
              });
            case 3:
              if (!(Number(row.excluded) === 1)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2, {
                error: 'That migration reservation is no longer active'
              });
            case 4:
              if (!(row.status !== 'inbound_awaiting')) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2, {
                error: 'Only unpaid migration reservations can be extended'
              });
            case 5:
              now = Date.now();
              _context3.n = 6;
              return this.mod.database.updateTransfer(row.id, {
                created_at: now
              });
            case 6:
              return _context3.a(2, this.clientReservation(_objectSpread(_objectSpread({}, row), {}, {
                created_at: now
              })));
          }
        }, _callee3, this);
      }));
      function extendReservation(_x5, _x6) {
        return _extendReservation.apply(this, arguments);
      }
      return extendReservation;
    }()
  }, {
    key: "recordManualMigration",
    value: function () {
      var _recordManualMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(tx) {
        var _tx$returnMessage, _tx$from;
        var data, publicKey, existing, open, inboundConfirmationBlockId, raw, id, rows, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              data = ((_tx$returnMessage = tx.returnMessage()) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.data) || {};
              publicKey = data.pk || ((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '';
              if (publicKey) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, null);
            case 1:
              _context4.n = 2;
              return this.mod.database.getTransfers({
                requester_publickey: publicKey,
                purpose: 'migration',
                mode: 'manual'
              });
            case 2:
              existing = _context4.v;
              open = (existing || []).find(function (row) {
                return !Number(row.excluded) && row.email === (data.email || '') && OPEN_STATUSES.includes(row.status);
              });
              if (!open) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, open);
            case 3:
              _context4.p = 3;
              _context4.n = 4;
              return this.app.blockchain.getLatestBlockId();
            case 4:
              raw = _context4.v;
              inboundConfirmationBlockId = typeof raw === 'bigint' ? Number(raw) : raw;
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t2 = _context4.v;
              inboundConfirmationBlockId = null;
            case 6:
              if (!(!Number.isInteger(inboundConfirmationBlockId) || inboundConfirmationBlockId < 0 || !Number.isSafeInteger(inboundConfirmationBlockId))) {
                _context4.n = 7;
                break;
              }
              return _context4.a(2, null);
            case 7:
              _context4.n = 8;
              return this.mod.database.insertTransfer({
                purpose: 'migration',
                mode: 'manual',
                requester_publickey: publicKey,
                recipient_publickey: publicKey,
                status: 'inbound_awaiting',
                email: data.email || '',
                payload: JSON.stringify({
                  erc20: data.erc20 || '',
                  email: data.email || '',
                  source: 'manual-request'
                }),
                inbound_sender: data.erc20 || '',
                inbound_confirmation_block_id: inboundConfirmationBlockId,
                outbound_ticker: 'SAITO',
                created_at: tx.timestamp || Date.now()
              });
            case 8:
              id = _context4.v;
              _context4.n = 9;
              return this.mod.database.getTransfers({
                id: id
              });
            case 9:
              rows = _context4.v;
              return _context4.a(2, rows[0]);
          }
        }, _callee4, this, [[3, 5]]);
      }));
      function recordManualMigration(_x7) {
        return _recordManualMigration.apply(this, arguments);
      }
      return recordManualMigration;
    }()
  }, {
    key: "confirmManualMigrationDeposit",
    value: function () {
      var _confirmManualMigrationDeposit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, amount, txHash) {
        var _this$mod$creditDepos, _this$mod;
        var rows, row, allocated, claimed;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.mod.database.getTransfers({
                id: Number(id)
              });
            case 1:
              rows = _context5.v;
              row = rows === null || rows === void 0 ? void 0 : rows[0];
              if (!(!row || row.purpose !== 'migration' || row.mode !== 'manual')) {
                _context5.n = 2;
                break;
              }
              throw new Error('No manual migration matches that id.');
            case 2:
              if (!(Number(row.excluded) === 1)) {
                _context5.n = 3;
                break;
              }
              throw new Error('That transfer is excluded from processing.');
            case 3:
              if (!row.outbound_tx_sig) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2, row);
            case 4:
              if (['inbound_awaiting', 'inbound_broadcast'].includes(row.status)) {
                _context5.n = 5;
                break;
              }
              throw new Error('Migration deposit cannot be verified from its current status.');
            case 5:
              allocated = this.allocationForDeposit(amount);
              if (txHash) {
                _context5.n = 6;
                break;
              }
              throw new Error('Migration deposit hash is required.');
            case 6:
              _context5.n = 7;
              return this.mod.database.claimInboundPayment(row.id, {
                status: 'inbound_confirmed',
                inbound_amount: String(allocated),
                outbound_amount: String(allocated),
                inbound_tx_hash: txHash,
                inbound_confirmations: 1,
                inbound_confirmations_required: 1
              });
            case 7:
              claimed = _context5.v;
              if (claimed !== null && claimed !== void 0 && claimed.ok) {
                _context5.n = 8;
                break;
              }
              throw new Error('Migration deposit was already recorded.');
            case 8:
              (_this$mod$creditDepos = (_this$mod = this.mod).creditDepositAddress) === null || _this$mod$creditDepos === void 0 || _this$mod$creditDepos.call(_this$mod, row.inbound_address, amount, txHash);
              _context5.n = 9;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 9:
              return _context5.a(2, _context5.v[0]);
          }
        }, _callee5, this);
      }));
      function confirmManualMigrationDeposit(_x8, _x9, _x0) {
        return _confirmManualMigrationDeposit.apply(this, arguments);
      }
      return confirmManualMigrationDeposit;
    }()
  }, {
    key: "clientReservation",
    value: function clientReservation(row) {
      return {
        address: row.inbound_address || row.address,
        ticker: row.inbound_ticker || row.ticker,
        id: row.id,
        status: row.status,
        mixin_id: row.inbound_mixin_user_id || row.mixin_id,
        inbound_amount: row.inbound_amount || '',
        outbound_amount: row.outbound_amount || '',
        reserved_until: row.reserved_until != null ? Number(row.reserved_until) : Number(row.created_at) + this.mod.transfers.reservation_ms,
        error: null
      };
    }
  }]);
}();
module.exports = MigrationService;